import styled from '@emotion/styled';
import { AdapterLuxon } from '@mui/x-date-pickers/AdapterLuxon';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers';

const DateLabel = styled.div`
  /* font-size: 1.2rem; */
  /* font-weight: 500; */
  margin-bottom: .4rem;
  padding-left: 1px;
`;

const MuiDatePicker = ({ name = "sample", label, size="small", fullWidth = true, value, onChange, style, ...props }) => {
  return (
    <LocalizationProvider dateAdapter={AdapterLuxon}>
      <div>
        <DateLabel>{label}</DateLabel>
        <DatePicker name={name} value={value} onChange={onChange} slotProps={{ textField: { size, fullWidth} }} sx={style} />
      </div>
    </LocalizationProvider>
  )
}

export default MuiDatePicker;